<template>
  <div class="config row">
    <div class='col-xs-12 mt-sm-1'>
      <div :class="computedClassHeader">
        Configuração / Ajustes
      </div>
      <b-card-group deck :class="computedClass">
        <b-card align="center">
          <div slot='header'>
            <h4>{{!generalForm ? 'Gerais' : 'Editar configurações gerais'}}</h4>
          </div>
          <div class='card-text start-xs'>
            <div v-if='!generalForm'>
              <p><strong>TEMPO AUTONOMIA DA BATERIA:</strong> {{generalSettings.SHUTDOWN_TIMER}} min</p>
              <p><strong>TEMPO MÁXIMO EM MODO MANUAL:</strong> {{generalSettings.MANUAL_TIMER}} min</p>
              <p><strong>PACOTES ENVIADOS NO PING:</strong> {{generalSettings.PING_PACKAGES}} pacotes</p>
            </div>
            <div v-else>
              <b-form novalidate @keyup.enter='submitGeralConfig'>
                <b-form-text id='batInputLiveHelp'>
                  Autonomia da bateria *
                </b-form-text>
                <b-form-input v-model='editGeneralSett.SHUTDOWN_TIMER'
                              placeholder='Canal'
                              aria-describedby='batInputLiveHelp batInputLiveFeedback'
                              type='number'
                              :state='batState'
                              :min='0'>
                </b-form-input>
                <b-form-invalid-feedback v-if='!batState' id='batInputLiveFeedback'>
                  Campo inválido.
                </b-form-invalid-feedback>
                <b-form-text id='manualInputLiveHelp'>
                  Tempo máximo em manual *
                </b-form-text>
                <b-form-input v-model='editGeneralSett.MANUAL_TIMER'
                              placeholder='Time out'
                              aria-describedby='manualInputLiveHelp manualInputLiveFeedback'
                              type='number'
                              :state='manualState'
                              :min='0'>
                </b-form-input>
                <b-form-invalid-feedback v-if='!manualState' id='manualInputLiveFeedback'>
                  Campo inválido.
                </b-form-invalid-feedback>
                <b-form-text id='packInputLiveHelp'>
                  Número de pacotes enviados no ping *
                </b-form-text>
                <b-form-input v-model='editGeneralSett.PING_PACKAGES'
                              placeholder='Tentativas'
                              aria-describedby='packInputLiveHelp packInputLiveFeedback'
                              type='number'
                              :state='packState'
                              :min='0'>
                </b-form-input>
                <b-form-invalid-feedback v-if='!packState' id='packInputLiveFeedback'>
                  Campo inválido.
                </b-form-invalid-feedback>
              </b-form>
            </div>
          </div>
          <footer slot='footer'
                  class='row around-xs'>
            <b-btn variant='3v3'
                   size='sm'
                   v-if='!generalForm'
                  @click='showGeral()'><pencil-icon title='' /></b-btn>
            <b-btn variant='red'
                   size='sm'
                   v-if='generalForm'
                  @click='generalForm = false'><close-icon title='' /></b-btn>
            <b-btn variant='3v3'
                   size='sm'
                   v-if='generalForm'
                  @click='submitGeralConfig()'><save-icon title='' /></b-btn>
          </footer>
        </b-card>
        <b-card align="center">
          <div slot='header'>
            <h4>{{!clockForm ? 'Relógio do Sistema' : 'Editar relógio'}}</h4>
          </div>
          <div class='card-text start-xs'>
            <div v-if='!clockForm'>
              <p><strong>HORÁRIO:</strong> {{systemDate.DATETIME}}</p>
            </div>
            <b-form novalidate v-else @keyup.enter='submitDateTime'>
              <b-form-text id='dateInputLiveHelp'>
                Data atual *
              </b-form-text>
              <b-form-input v-model='editDateTime.date'
                            aria-describedby='dateInputLiveHelp dateInputLiveFeedback'
                            type='date'
                            :state='dateState'>
              </b-form-input>
              <b-form-invalid-feedback v-if='!dateState' id='dateInputLiveFeedback'>
                Campo inválido.
              </b-form-invalid-feedback>
              <b-form-text id='timeInputLiveHelp'>
                Horário atual *
              </b-form-text>
              <b-form-input v-model='editDateTime.time'
                            aria-describedby='timeInputLiveHelp timeInputLiveFeedback'
                            type='time'
                            :state='timeState'>
              </b-form-input>
              <b-form-invalid-feedback v-if='!timeState' id='timeInputLiveFeedback'>
                Campo inválido.
              </b-form-invalid-feedback>
            </b-form>
          </div>
          <footer slot='footer'
                  class='row around-xs'>
            <b-btn variant='3v3'
                  size='sm'
                  v-if='!clockForm'
                  @click='showClock()'><pencil-icon title='' /></b-btn>
            <b-btn variant='red'
                  size='sm'
                  v-if='clockForm'
                  @click='clockForm = false'><close-icon title='' /></b-btn>
            <b-btn variant='3v3'
                  size='sm'
                  v-if='clockForm'
                  @click='submitDateTime()'><save-icon title='' /></b-btn>
          </footer>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import { settings } from '@/api'

export default {
  name: 'settings',
  props:{
    mobile: Boolean
  },
  created() {
    settings.generalSettings().then(ret => {
      this.generalSettings = ret;
      return settings.systemDate();
    }).then(ret => {
      this.systemDate = ret;
    }).catch(err => console.log(err));
  },
  data () {
    return {
      generalForm: false,
      clockForm: false,
      editDateTime: {
        date: '',
        time: ''
      },
      editGeneralSett: {
        SHUTDOWN_TIMER: null,
        MANUAL_TIMER: null,
        PING_PACKAGES: null
      },
      generalSettings: {
        ID: null,
        UPDATE: '2000-00-00T00:00:00.000Z',
        SHUTDOWN_TIMER: null,
        MANUAL_TIMER: null,
        PING_PACKAGES: null
      },
      systemDate: {
        DATETIME:'Sun  1 Jan 00:00:0 -00 2000\n'
      },
    }
  },
  computed: {
    computedClass(){
      if(this.mobile){
        return "mobile-header pt-5"
      }
      return "desktop-header mt-4"
    },
    computedClassHeader(){
      if(this.mobile){
        return "page-title config-title-mobile col-xs-12  mt-0"
      }
      return "page-title config-title col-xs-12  mt-0"
      
    },
    batState () {
      return this.editGeneralSett.SHUTDOWN_TIMER !== '';
    },
    manualState () {
      return this.editGeneralSett.MANUAL_TIMER !== '';
    },
    packState () {
      return this.editGeneralSett.PING_PACKAGES !== '';
    },
    dateState () {
      return this.editDateTime.date !== '';
    },
    timeState () {
      return this.editDateTime.time !== '';
    },
  },
  methods: {
    resetForm(type) {
      if (type == 'general') {
        this.editGeneralSett.SHUTDOWN_TIMER = this.generalSettings.SHUTDOWN_TIMER ? this.generalSettings.SHUTDOWN_TIMER : null;
        this.editGeneralSett.MANUAL_TIMER = this.generalSettings.MANUAL_TIMER ? this.generalSettings.MANUAL_TIMER : null;
        this.editGeneralSett.PING_PACKAGES = this.generalSettings.PING_PACKAGES ? this.generalSettings.PING_PACKAGES : null;
      }
      if (type == 'clock') {
        this.editDateTime.date = '';
        this.editDateTime.time = '';
      }
    },
    showGeral() {
      this.resetForm('general');
      this.generalForm = true;
    },
    submitGeralConfig(evt) {
      if (this.batState &&
          this.manualState &&
          this.packState) {
        let data = {
          ID: this.generalSettings.ID,
          SHUTDOWN_TIMER: this.editGeneralSett.SHUTDOWN_TIMER,
          MANUAL_TIMER: this.editGeneralSett.MANUAL_TIMER,
          PING_PACKAGES: this.editGeneralSett.PING_PACKAGES
        }
        this.generalForm = false;
        settings.updateConfigGeneral(data).then(ret => {
          alert(ret.log,ret.alert);
          if (ret.status)
            settings.generalSettings().then(genSet => this.generalSettings = genSet);
        }).catch(err => {
          console.log(err);
          alert('Ocorreu um erro.');
        });
      }
    },
    showClock() {
      this.resetForm('clock');
      this.clockForm = true;
    },
    dateFormat(date) {
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      date = date.split('-');
      return date[2]+' '+months[parseInt(date[1]-1)].toUpperCase()+' '+date[0];
    },
    submitDateTime(evt) {
      if (this.timeState &&
          this.dateState) {
        let data = { 'DATETIME': this.dateFormat(this.editDateTime.date) + ' ' + this.editDateTime.time };
        this.clockForm = false;
        settings.updateDatetimeSettings(data).then(ret => {
          alert(ret.log,ret.alert);
          if (ret.status)
            settings.systemDate().then(systemDate => this.systemDate = systemDate);
        }).catch(err => {
          alert('Ocorreu um erro.')
        });
        // this.resetForm('clock'); //se a resposta da requisição for ok, reseta o formulário e fecha
      }
    }
  }
}
</script>

<style scoped>
.card-text>div>p{
  color:var(--text-gray-primary);
}
.config-title-mobile{
  top: 36px;

}

.config-title{
  max-height: 1.1em;
  padding: 0 0 4px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
@media screen and (max-width:767px){
  .card-text{
    font-size: 0.88em;
  }
}
</style>
